export const buttonPalette = {
  primary:   { c: "#000f59", fg: "#ffffff" },
  secondary: { c: "#0022cc", fg: "#ffffff" },
  tertiary:  { c: "#fc9006", fg: "#0d1220" },
  success:   { c: "#2e7d32", fg: "#ffffff" },
  danger:    { c: "#d32f2f", fg: "#ffffff" },
  orion:     { c: "#4b7ef4", fg: "#ffffff" },
};
